import script from "./ChatDialogsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatDialogsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ChatDialogsPanel.vue?vue&type=style&index=0&id=6dec5b42&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dec5b42"]])

export default __exports__